import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon1 from "../../images/icon/research.gif";
import icon2 from "../../images/icon/faq.gif";
import icon3 from "../../images/icon/folder.gif";
import icon4 from "../../images/icon/chat.gif";
import icon5 from "../../images/icon/phone-contact.gif";
import sIcon from "../../images/icon/arrow-black.svg";

const HelpUs = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Help</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="service pt-65 pb-130">
          <div className="container">
            <div className="row mt-none-30">

              {/* KYC Upload */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">KYC Upload</h3>
                      <span className="xb-item--contact">
                        Quick, secure, and fully compliant with international remittance standards.
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon1} alt="KYC Upload" />
                      </div>
                      <Link
                        to="/kycupload"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      to="/kycupload"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Onboarding FAQs */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Onboarding FAQs</h3>
                      <span className="xb-item--contact">
                        Your Questions Answered – Start Sending Money with Confidence
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon2} alt="Onboarding FAQs" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/onboardingFAQ"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/onboardingFAQ"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Data Safety */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Data Safety</h3>
                      <span className="xb-item--contact">
                        At TigrisPay, safeguarding your information is our highest priority.
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon3} alt="Data Safety" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/datasafty"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/datasafty"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* General FAQs */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">General FAQs</h3>
                      <span className="xb-item--contact">
                        Frequently Asked Questions
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon4} alt="General FAQs" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/generalFaq"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/generalFaq"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

              {/* Contact Info */}
              <div className="col-lg-4 col-md-6 mt-30">
                <div className="service-box">
                  <div className="service-item">
                    <div className="xb-item--holder mb-85">
                      <h3 className="xb-item--title">Contact Info</h3>
                      <span className="xb-item--contact">
                        Need Help? We’re Here for You.
                      </span>
                    </div>
                    <div className="xb-item--icon ul_li_between">
                      <div className="xb-item--img">
                        <img src={icon5} alt="Contact Info" />
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="xb-item--arrow"
                      >
                        <img src={sIcon} alt="arrow" />
                      </Link>
                    </div>
                    <Link
                      onClick={ClickHandler}
                      to="/contact"
                      className="xb-overlay"
                    ></Link>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default HelpUs;
